export default "__VITE_ASSET__CfVHcSpb__"